<template>
  <div class="row">

    <div class="col-12" v-if="this.$route.query.id != null">
      <please-wait-modal/>
      <ul class="nav nav-tabs" id="user_tab" role="tablist">
        <li class="nav-item" v-for="(data,index) in arr" :key="index">
          <a :href="'#'+data.replace(/ /g,'_')" class="nav-link" :class="{'active': index == 0}" :id="data+'-tab'" data-toggle="tab" role="tab" :aria-controls="data" :aria-selected="index == 0 ? 'true' : 'false'">{{ data }}</a>
        </li>
      </ul>
      <div class="tab-content" id="userTabContent">
        <div class="tab-pane fade" :class="{'show active': index == 0}" :id="data.replace(/ /g,'_')" role="tabpanel" :aria-labelledby="data+'-tab'" v-for="(data,index) in arr" :key="index">
          <div class="mt-3" >
            <mitra-profile :data="data_user" @on-save="save" @on-force-login="force_login" :is_edited="is_edited" v-if="index == 0"/>
            <custom-table :arr="data_agent.arr" :total_page="data_agent.total_page" url_detail="/user/action/agent" :arr_header="data_agent.arr_header" v-if="index == 1"/>
            <custom-table :arr="data_helper.arr" :total_page="data_helper.total_page" url_detail="/user/action" :arr_header="data_helper.arr_header" v-if="index == 2"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import please_wait_modal from '@/layout/please_wait_modal'
import custom_table from '@/layout/table'
import mitra_profile from '@/pages/user/mitra_component/profile'

export default {
  components:{
    'custom-table': custom_table,
    'mitra-profile': mitra_profile,
    'please-wait-modal': please_wait_modal,
  },
  data(){
    return{
      arr:[
        'profil',
        'agen',
        'helper',
      ],
      data_agent: {
        arr:[
          {
            pekerjaan: 'Asisten rumah tangga',
            'tanggal mulai': moment().format('DD MMM YYYY'),
            status: 'wait',
          }
        ],
        arr_header: ['pekerjaan','tanggal mulai','status'],
        total_page: 1,
      },
      data_helper: {
        arr:[
          {
            pekerjaan: 'Asisten rumah tangga',
            'tanggal mulai': moment().format('DD MMM YYYY'),
            status: 'wait',
          }
        ],
        arr_header: ['pekerjaan','tanggal mulai','status'],
        total_page: 1,
      },
      data_user:{
        name: '',
        email: '',
        address: '',
        phone: '',
        city: '',
        picture: null,
        file_name: null,
      },
      is_edited: false,
      type: {
        id: ''
      }
    }
  },
  async created(){
    await this.get_type()
    await this.get_data()
    await this.get_agent()
    await this.get_helper()
  },
  methods: {
    async get_data(){
      try{
        var response = await axios.get(base_url+'/mitra?id='+this.$route.query.id)

        var response_data = response.data

        if(response_data.status == "success"){
          response_data.data.city = response_data.data.city_id
          response_data.data.phone_number = response_data.data.phone
          response_data.data.file_name = response_data.data.file_name+'&random='+moment().format('YYYYMMDDHHmmss')
          this.data_user = response_data.data
          console.log(this.data_user)
        }
        else
          this.$toasted.show(response_data.message)
      } catch(e) {
        this.$toasted.show(e)
      }
    },
    async get_type(){
      try{
        var response = await axios.get(base_url+'/type?name=helper')

        var response_data = response.data

        if(response_data.status == "success"){
          this.type = response_data.data.data[0]
        }
        else
          this.$toasted.show(response_data.message)
      } catch(e) {
        this.$toasted.show(e)
      }
    },
    async get_agent(){
      try{
        var response = await axios.get(base_url+'/agent?mitra_id='+this.$route.query.id+'&api_type=web-admin')

        var response_data = response.data

        if(response_data.status == "success"){
          this.data_agent.arr = response_data.arr
          this.data_agent.arr_header = response_data.arr_header
          this.data_agent.arr_id = response_data.arr_id
          this.data_agent.total_page = response_data.total_page
        }
        else
          this.$toasted.show(response_data.message)
      } catch(e) {
        this.$toasted.show(e)
      }
    },
    async get_helper(){
      try{
        var response = await axios.get(base_url+'/user?mitra_id='+this.$route.query.id+'&api_type=web-admin&arr_type='+JSON.stringify([this.type.id]))

        var response_data = response.data

        if(response_data.status == "success"){
          this.data_helper.arr = response_data.arr
          this.data_helper.arr_header = response_data.arr_header
          this.data_helper.arr_id = response_data.arr_id
          this.data_helper.total_page = response_data.total_page
        }
        else
          this.$toasted.show(response_data.message)
      } catch(e) {
        this.$toasted.show(e)
      }
    },
    async force_login(){
      try{
        $('#please_wait_modal').modal('show')

        var data = {}
        data.id = this.data_user.id

        var response = await axios.post(base_url+'/mitra/force-login',data)

        setTimeout(() => {
          $('#please_wait_modal').modal('hide')
        },500)

        var response_data = response.data
        if(response_data.status == "success"){
          this.get_data()
        }
        else
          this.$toasted.show(response_data.message)
      } catch(e){
        $('#please_wait_modal').modal('hide')
        this.$toasted.show(e.message)
      }
    },
    async save(data_user){
      try{
        console.log(this.data_user)
        var total = 0
        var counter = 0
        var arr_header = ['name','email','address','phone_number','city']
        total = arr_header.length

        for(let x in arr_header){
          if(data_user[arr_header[x]] == ''){
            this.$toasted.show(arr_header[x].replace(/_/g,' ')+" is empty")
            break
          }
          counter++
        }

        if(counter == total){
          $('#please_wait_modal').modal('show')
          var data = JSON.parse(JSON.stringify(data_user))
          if(data.is_change_picture != null && data.is_change_picture)
            data.image = await image2base64(data.picture)
          data.city = {
            id: data_user.city
          }
          data.phone = data_user.phone_number
          data.id = this.$route.query.id

          var response = await axios.put(base_url+'/mitra',data)

          setTimeout(() => {
            $('#please_wait_modal').modal('hide')
          },500)
          var response_data = response.data

          if(response_data.status == "success"){
            this.is_edited = true
            this.get_data()

            var context = this
            setTimeout(() => {
              context.is_edited = false
            },100)
          }
          else
            this.$toasted.show(response_data.message)
        }
      } catch(e){
        $('#please_wait_modal').modal('hide')
        this.$toasted.show(e)
      }
    }
  }
}
</script>
